module.exports = __webpack_public_path__ + "img/French.2e7ac41a.svg";